<tile 
  title="{{ 'total_work_items_completed' | translate }}" 
  val="{{ allTimeCount | undefinedNumber }}" 
  icon="wrench" 
  change="{{ sinceLastBillingDateCount }}" 
  [showChange]="showChange"
  help="{{ 'total_work_items_completed_help' | translate }}">
</tile>